//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('stockHistory', {
//        templateUrl: 'views/components/views/stockHistory/stockHistory.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stateService', 'stockHistoryService', 'rememberService', function ($stateParams, utilityService, stateService, stockHistoryService, rememberService) {
            
//    		// #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyNo = $stateParams.stock_keyno;

//            let variableNames = {
//                date_fom: '',
//                date_tom: '',
//                dateselector_index: ''
//            };

//    		vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                ],
//    			setting: {},
//    			itemsListHistories: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//    		// #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await stockHistoryService.getStockHistory({ stock_keyno: stockKeyNo }))[0];
//            }
    		
//            async function loadStockHistories() {
//                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                vm.model.itemsListHistories = [];

//                return vm.model.itemsListHistories = await stockHistoryService.listStockHistories(vm.model.setting);
//    		}

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'date_fom':
//                    case 'date_tom':
//                    case 'dateselector_index':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region DATE RANGE FIELD CHANGE FUNCTION

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = dateInterval === '-1' ? vm.model.setting.dateselector_index : dateInterval;
                
//                if (vm.model.setting.date_fom) rememberFunc('date_fom');
//                if (vm.model.setting.date_tom) rememberFunc('date_tom');
//                if (vm.model.setting.dateselector_index && vm.model.setting.dateselector_index !== -1) rememberFunc('dateselector_index');

//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
//                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
//                    loadStockHistories();
//                }
//            };

//		    // #endregion DATE RANGE FIELD CHANGE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadStockHistories();
//            }

//		    // #endregion ON INIT FUNCTION
//    	}]
//    });
//})();
